<template>
  <div>
        <!-- <Faxeslist msg="Welcome to PharmFax.com"/> -->
    <hero />
    <hr />
    <!-- <home-content /> -->
  </div>
</template>

<script>
import Hero from "../components/Hero";
// import HomeContent from "../components/HomeContent";
// import Faxeslist from '@/components/Faxeslist.vue'


export default {
  name: "home",
  components: {
    Hero,
    // HomeContent,
    // Faxeslist
  }
};
</script>

<style lang="scss" scoped>
.next-steps {
  .fa-link {
    margin-right: 5px;
  }
}
</style>
